import React from "react";
import styled from "styled-components";

/**
 * The watchdog screens read the issue analysis from a file per workspace in public/, written by
 * workbench/backlog/feature_watchdog's generators. A workspace it has not run for has no file, and the
 * page says so rather than rendering an empty table that reads as a site with no traffic.
 */
export default function FixtureGate({ error, children }) {
    if (error) return <Note><Line>Issue analysis has not run for this workspace.</Line></Note>;
    return children ?? <Note><Line>Loading…</Line></Note>;
}

const Note = styled.div`
    border: 1px solid #e8edf4;
    border-radius: 12px;
    background: #fbfcfe;
    padding: 18px 20px;
    @media (max-width: 600px) { border-radius: 0; border-left: none; border-right: none; }
`;

const Line = styled.div`
    font-size: 0.92rem;
    font-weight: 600;
    color: #334155;
`;

